// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AboutUs_wrap__sqiqo","about":"AboutUs_about__1I8oj"};